// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/app/edit-overlay/edit-overlay.component.css */
.edit-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0; /* Cover the entire container */
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
  border-radius: 10px; /* Match the border-radius of the image container */
}

.edit-overlay .material-icons {
  font-size: 24px; /* Adjust icon size */
  color: white; /* Set icon color to white */
}

:host:hover .edit-overlay {
  opacity: 1; /* Show overlay on hover */
  cursor: pointer;
}

/* New media query for mobile devices */
@media (max-width: 768px) { /* Adjust the max-width as needed */
  :host .edit-overlay {
    opacity: 1; /* Always show overlay on mobile */
    cursor: default; /* Change cursor to default */
  }
}`, "",{"version":3,"sources":["webpack://./src/app/profiles/dashboard/elements/edit-overlay/edit-overlay.component.scss"],"names":[],"mappings":"AAAA,oDAAA;AACA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA,EAAA,+BAAA;EACA,oCAAA,EAAA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,wBAAA;EACA,mBAAA,EAAA,mDAAA;AACF;;AAGA;EACE,eAAA,EAAA,qBAAA;EACA,YAAA,EAAA,4BAAA;AAAF;;AAGA;EACE,UAAA,EAAA,0BAAA;EACA,eAAA;AAAF;;AAGA,uCAAA;AACA,4BAAA,mCAAA;EACE;IACE,UAAA,EAAA,kCAAA;IACA,eAAA,EAAA,6BAAA;EAAF;AACF","sourcesContent":["/* src/app/edit-overlay/edit-overlay.component.css */\n.edit-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0; /* Cover the entire container */\n  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.3s;\n  border-radius: 10px; /* Match the border-radius of the image container */\n}\n\n\n.edit-overlay .material-icons {\n  font-size: 24px; /* Adjust icon size */\n  color: white; /* Set icon color to white */\n}\n\n:host:hover .edit-overlay {\n  opacity: 1; /* Show overlay on hover */\n  cursor: pointer;\n}\n\n/* New media query for mobile devices */\n@media (max-width: 768px) { /* Adjust the max-width as needed */\n  :host .edit-overlay {\n    opacity: 1; /* Always show overlay on mobile */\n    cursor: default; /* Change cursor to default */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
